export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-12">
      <div className="max-w-6xl mx-auto px-6 py-10 grid md:grid-cols-3 gap-6 text-sm text-white/60">
        <div>
          <div className="font-semibold text-white mb-2">The AIE Network</div>
          <p className="text-white/50">
            Independent media and education for business pros learning AI.
            Seven newsletters, 250,000+ readers.
          </p>
        </div>
        <div className="flex flex-col gap-1.5">
          <a href="https://theaie.net/publications" className="hover:text-white">Publications</a>
          <a href="https://theaie.net/events" className="hover:text-white">Events</a>
          <a href="https://allthingsai.org" className="hover:text-white">All Things AI</a>
          <a href="https://theaie.net/about" className="hover:text-white">About</a>
        </div>
        <div className="flex flex-col gap-1.5 md:items-end">
          <a href="https://x.com/mrhinkle" className="hover:text-white">X / @mrhinkle</a>
          <a href="https://www.linkedin.com/in/markrhinkle" className="hover:text-white">LinkedIn</a>
          <span className="text-white/40">© {new Date().getFullYear()} Peripety Labs, LLC</span>
        </div>
      </div>
    </footer>
  );
}
